import { useEffect, useState } from "react";

/**
 * Grafik kengligi — konteynerning HAQIQIY kengligi.
 *
 * Qat'iy `viewBox` bilan SVG konteynerga qarab cho'ziladi: keng kartada
 * 11px yorliq 20px bo'lib ketardi, tor kartada esa 7px ga tushardi. O'lchab
 * chizilgan grafikda bir piksel bir piksel bo'lib qoladi — yorliqlar har
 * joyda bir xil o'lchamda. `ResizeObserver` bo'lmagan muhitda (SSR, test)
 * zaxira kenglik ishlatiladi.
 *
 * Ref — callback: grafik ma'lumot kelgandan keyin chizilsa ham (avval
 * `null` qaytargan bo'lsa), kuzatuvchi o'sha paytda ulanadi.
 */
export const useMeasuredWidth = <T extends HTMLElement>(fallback: number) => {
  const [node, setNode] = useState<T | null>(null);
  const [width, setWidth] = useState(fallback);

  useEffect(() => {
    if (!node || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(entries => {
      const next = Math.round(entries[0]?.contentRect.width ?? 0);
      if (next > 0) setWidth(next);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return [setNode, width] as const;
};
